module.exports = __webpack_public_path__ + "39afbaa043f7770145c000daa79232be.MP3";